import { formatInTimeZone } from "date-fns-tz";
import { es } from "date-fns/locale";

export const formatTimeEsCO = (date) => {
  return formatInTimeZone(date, "America/Bogota", "h:mm aaaa", { locale: es });
};
